import { Typography } from "@mui/material";
import { type FC } from "react";

import { formatNumber } from "~/utils/formatValue";

interface IValueFieldProps {
  value: number | null;
}

export const ValueField: FC<IValueFieldProps> = ({ value }) => {
  if (!value) {
    return <Typography variant="caption">N/A</Typography>;
  }

  return <Typography variant="caption">{formatNumber(value)}</Typography>;
};
